import store from '@/store'
import { get } from 'lodash-es'
import { modelStateRegistry } from '@/utils/modelStateRegistry'
import { getAmenabilityColumnGroups } from './amenabilityColumnGroups'
import { buildAmenabilityColumnDef } from './amenabilityColumnsDef'
import {
  formatConstructedError,
  defaultResultKey,
  defaultChemicalKey,
  defaultResultsKey,
} from '@/utils/responseNormalizers'
import { createMetadataHelpers } from '../metadata'

const groupedKeys = get(modelStateRegistry, 'groupedModel.keys')
const namespace = 'amenability'
const { getName, getDescription, getEndpointIds } = createMetadataHelpers(`${namespace}/${groupedKeys.getMetadata}`)

const amenabilityAdapter = (modelId) => ({
  [modelId]: {
    chemicalKey: defaultChemicalKey,
    predictionsKey: defaultResultKey,
    errorKey: 'error',
    categoryId: 'amenabilityModels',
    formatError: (error) => formatConstructedError(error),
    getResults: () => store.getters[`${namespace}/${groupedKeys.getResultsForModel}`](modelId)?.[defaultResultsKey],
    getIsLoading: () => store.getters[`${namespace}/${groupedKeys.getIsLoadingForModel}`](modelId),
    getIsAborted: () => store.getters[`${namespace}/${groupedKeys.getIsAbortedForModel}`](modelId),
    fetch: (chemicals) => store.dispatch('amenability/predict', { structures: chemicals, modelId }),
    reset: () => store.commit(`${namespace}/${groupedKeys.RESET_STATE_FOR_MODEL}`, modelId),
    abort: () => store.commit(`${namespace}/${groupedKeys.ABORT_CURRENT_FETCH_FOR_MODEL}`, { modelId }),
    getParameters: getAmenabilityColumnGroups,
    getColumnDefBuilder: buildAmenabilityColumnDef,
    getName: () => getName(modelId),
    getDescription: () => getDescription(modelId),
  },
})

const getAmenabilityAdapters = () =>
  getEndpointIds().reduce((acc, modelId) => ({ ...acc, ...amenabilityAdapter(modelId) }), {})

export { getAmenabilityAdapters }
